import axios from '@/http/axios';

export default {
  newPaymentIntent: (oid, config: any = {}) => {
    return axios.post(`/service-payments/${oid}/new-payment-intent`, config);
  },
  preCalculatePrice: (config: any = {}) => {
    return axios.post(`/service-payments/pre-calculate-price`, config);
  },
  invoice: (oid) => {
    return axios.get(`/service-payments/${oid}/invoice`, {
      responseType: 'arraybuffer',
    });
  },
  fetch: (oid, config: any = {}) => {
    return axios.get(`/service-payments/${oid}`, config);
  },
  report: (config: any = {}) => {
    return axios.get(`/service-payments/report`, {
      ...config,
      responseType: 'arraybuffer',
    });
  },
  reminderEmail: (oid, config: any = {}) => {
    return axios.put(`/service-payments/${oid}/reminder-email`, config);
  },
};
